export const NAME = 'campaignSettings-guarantors';

export const guarantorItemHeight = 40;
